import React from 'react'
import './Header.css'
const Header = () => {
    return(
        <>
            <div className='header'>
                <div className='headingText'>Quotation</div>
                <div className='subHeadingText'>"Quotes worth remembering..."</div>
            </div>
        </>
    );
}

export default Header;